import { ImportTemplate } from '@/api/index'

export function importTemplateIsExistFile (data: any) {
  return ImportTemplate.request({
    method: 'post',
    url: '/IsExistFile',
    data
  })
}
export function importSavePGSData (data: any) {
  return ImportTemplate.request({
    method: 'post',
    url: '/SavePGSData',
    data
  })
}
export function importGetPageGridBond (data: any) {
  return ImportTemplate.request({
    method: 'post',
    url: '/GetPageGridBond',
    data
  })
}
// 文件上传
export function importInitializationTemplate (data: any) {
  return ImportTemplate.request({
    method: 'post',
    url: '/InitializationTemplate',
    data
  })
}
